if(!customElements.get('nosto-products-carousel')) {
  class NostoProductsCarousel extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {};
    }
  
    connectedCallback() {
      this.filterOutProducts();
      this.initSlider();
    }

    /**
     * Normalizes a string to match Liquid's handleize (lowercase, spaces to hyphens, strip non-alphanumeric).
     * Keeps JS filter in sync with check-hide-color.liquid so casing/spacing in settings match correctly.
     */
    handleizeColor(str) {
      if (typeof str !== 'string') return '';
      return str
        .replace(/\r\n|\r|\n/g, ' ')
        .toLowerCase()
        .trim()
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9-]/g, '')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '');
    }

    filterOutProducts() {
      // Used to remove the products that are marked to hide from the website
      const hideColors = Array.isArray(window.hideColorsArray) ? window.hideColorsArray : [];
      const hiddenColorsHandled = hideColors
        .filter(Boolean)
        .map((c) => this.handleizeColor(String(c).trim()));
      const allProducts = this.querySelectorAll('.swiper-slide');

      allProducts.forEach((product) => {
        const colorEl = product.querySelector('.card__current-color');
        if (!colorEl) return;
        const colorNameHandled = this.handleizeColor(colorEl.textContent.trim());
        if (hiddenColorsHandled.indexOf(colorNameHandled) > -1) {
          product.remove();
        }
      });
    }
  
    initSlider() {
      if (!this.querySelector('[data-slider]')) return;
  
      this.options = {
        slidesPerView: 1.6,
        slidesPerGroup: 1,
        spaceBetween: 10,
        loop: true,
        navigation: {
          prevEl: this.querySelector('.swiper-nav.swiper-button-prev'),
          nextEl: this.querySelector('.swiper-nav.swiper-button-next'),
        },
        breakpoints: {
          750: {
            slidesPerView: 2,
            slidesPerGroup: 2
          },
          992: {
            slidesPerView: 3,
            slidesPerGroup: 3
          },
          1024: {
            slidesPerView: 4,
            slidesPerGroup: 4
          }
        }
      };
  
      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.options,
      );
    }
  }
  
  customElements.define('nosto-products-carousel', NostoProductsCarousel);
}